/**
 * Color Swatch AJAX Navigation
 * Intercepts clicks on color variant links (that point to /products/...)
 * within the product info area. Instead of full page navigation,
 * fetches the target product page and swaps the product content inline.
 * Works with Combined Listings, apps, and theme-rendered color links.
 */
(function() {
  'use strict';

  // Never hijack navigation inside the Shopify theme editor. The editor manages
  // the preview iframe's history/navigation itself; intercepting clicks and
  // reloading on popstate fights the editor and can leave the preview blank.
  var inThemeEditor = !!(window.Shopify && window.Shopify.designMode);

  // Track whether WE performed an AJAX navigation. We only react to popstate
  // when our own pushState put us into that state — otherwise we'd reload on the
  // editor's (and the browser's) own history changes, causing a blank/loop.
  var ajaxNavUsed = false;

  document.addEventListener('click', function(e) {
    if (inThemeEditor) return;

    // If bundle mode is active, let bundle-qty.js handle color clicks
    if (window.__bundleMode && window.__bundleMode.active) return;

    // Match any link to /products/ inside the product info column or variant selectors
    var link = e.target.closest('a[href*="/products/"]');
    if (!link) return;

    // Skip if the click target is a radio input or label for a radio (native swatches)
    if (e.target.matches('input[type="radio"], label[for]')) return;

    var href = link.getAttribute('href');
    if (!href || !href.includes('/products/')) return;

    // Only intercept links within the product section (not nav, footer, pair-with, etc.)
    var productSection = document.querySelector('[data-section-type="product"]');
    if (!productSection) return;

    // Must be inside Product__Info or a color/variant related container
    var inProductInfo = link.closest('.Product__Info, .Product__InfoWrapper, .ProductForm, .ProductForm__Option, .ColorSwatchList, .VariantSelector, .combined-listing');
    if (!inProductInfo) return;

    // Skip if it's a "Pair With" link
    if (link.closest('.PairWith, .PairPane')) return;

    // Skip links that are clearly not color swatches (e.g. has long text content)
    var linkText = (link.textContent || '').trim();
    if (linkText.length > 30) return;

    // Check we're not navigating to the current page
    var currentPath = window.location.pathname;
    var linkUrl = new URL(href, window.location.origin);
    var linkPath = linkUrl.pathname;
    // Only AJAX-swap same-origin product pages. Cross-origin links must use a
    // normal browser navigation — never fetch + execute scripts from another origin.
    if (linkUrl.origin !== window.location.origin) return;
    if (linkPath === currentPath) return;

    e.preventDefault();
    e.stopPropagation();

    // Show loading state
    productSection.style.opacity = '0.5';
    productSection.style.pointerEvents = 'none';
    productSection.style.transition = 'opacity 0.15s';

    // Hard fallback: if anything about the swap goes wrong, do a normal page
    // navigation so the customer NEVER ends up looking at a blank product.
    function fallbackNavigate() {
      try {
        productSection.style.opacity = '1';
        productSection.style.pointerEvents = '';
      } catch (e) {}
      window.location.href = href;
    }

    fetch(href, { credentials: 'same-origin' })
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var newSection = doc.querySelector('[data-section-type="product"]');
        // Re-query the live section in case the DOM changed while fetching.
        var liveSection = document.querySelector('[data-section-type="product"]');

        // If we can't confidently locate both sections, fall back to a real
        // navigation rather than risk leaving the page in a broken state.
        if (!newSection || !liveSection || !liveSection.parentNode) {
          fallbackNavigate();
          return;
        }

        var parent = liveSection.parentNode;
        var oldSectionId = liveSection.getAttribute('data-section-id') || '';

        // Import the new node into this document (scripts imported this way do
        // NOT auto-execute — we run the safe ones manually below).
        var replacement = document.importNode(newSection, true);
        var newSectionId = replacement.getAttribute('data-section-id') || oldSectionId;

        // 1) Tell the theme to tear down the old ProductSection instance
        //    (destroys its gallery carousel, listeners, etc.).
        if (oldSectionId) {
          document.dispatchEvent(new CustomEvent('shopify:section:unload', {
            detail: { sectionId: oldSectionId }
          }));
        }

        // 2) Swap the DOM.
        parent.replaceChild(replacement, liveSection);

        // 3) Re-run inline scripts that are safe to re-run. Skip:
        //    - external/src scripts (already loaded globally), and
        //    - custom-element definitions (customElements.define throws a
        //      DOMException on a duplicate name; those elements are already
        //      registered and auto-upgrade when inserted into the DOM).
        replacement.querySelectorAll('script').forEach(function(oldScript) {
          try {
            if (oldScript.src) return;
            var code = oldScript.textContent || '';
            if (/customElements\s*\.\s*define/.test(code)) return;
            var newScript = document.createElement('script');
            if (oldScript.type) newScript.type = oldScript.type;
            newScript.textContent = code;
            oldScript.parentNode.replaceChild(newScript, oldScript);
          } catch (e) {
            // A single bad script must never blank the whole product.
          }
        });

        // 4) Re-initialise the theme's ProductSection. The theme's handler reads
        //    event.target.querySelector('[data-section-id]'), so the event MUST
        //    be dispatched on the wrapper that CONTAINS the section, not on the
        //    section itself.
        try {
          parent.dispatchEvent(new CustomEvent('shopify:section:load', {
            bubbles: true,
            detail: { sectionId: newSectionId }
          }));
        } catch (e) {}

        // Let apps know the page content changed.
        try { document.dispatchEvent(new Event('page:loaded')); } catch (e) {}

        // Update URL + title without a reload.
        ajaxNavUsed = true;
        window.history.pushState({}, '', href);
        var newTitle = doc.querySelector('title');
        if (newTitle) document.title = newTitle.textContent;

        // Re-init common helpers (guarded — none of these may blank the page).
        try { if (window.lazySizes) lazySizes.init(); } catch (e) {}
        try { if (window.SPR) window.SPR.initDomEls(); } catch (e) {}
        try { if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init(); } catch (e) {}
        try { observeForSwatches(); } catch (e) {}

        // Always make sure the product is visible again.
        replacement.style.opacity = '1';
        replacement.style.pointerEvents = '';
      })
      .catch(function(err) {
        console.error('Color swap failed, falling back to navigation:', err);
        fallbackNavigate();
      });
  });

  // Handle browser back/forward
  window.addEventListener('popstate', function() {
    // Only reload if we navigated via our own AJAX swap. Reloading on every
    // popstate breaks the Shopify theme editor (it drives history itself).
    if (inThemeEditor || !ajaxNavUsed) return;
    window.location.reload();
  });

  // === COLOUR SWATCHES: collapse + Patterns/Colours toggle ===
  // Easify renders swatches client-side. Two possible modes:
  //   tpo_image-swatches-wrapper  — app has pattern images configured
  //   tpo_color-swatches-wrapper  — app shows solid colour circles
  // We:
  //   1. Wait for either wrapper via MutationObserver
  //   2. Add a "Patterns | Colours" pill toggle next to the option label
  //   3. In image mode (show_pattern_swatches=true): apply pattern images silently
  //   4. In colour mode (show_pattern_swatches=false): show solid colour circles
  //   5. Collapse to max 5 + "More colours ▾" either way
  // Mode is set once by the store owner in the theme customizer — no public toggle.

  var _imageCache = {}; // handle → image src

  function getProductImage(handle) {
    if (_imageCache[handle] !== undefined) return Promise.resolve(_imageCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.json')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(data) {
        var src = data && data.product && data.product.images && data.product.images[0]
          ? data.product.images[0].src : null;
        if (src) src = src.indexOf('?') > -1 ? src + '&width=80' : src + '?width=80';
        _imageCache[handle] = src;
        return src;
      })
      .catch(function() { _imageCache[handle] = null; return null; });
  }

  // Read colour codes from Easify's window config: label (lowercase) → [hex, hex?]
  function buildColorMap() {
    var map = {};
    try {
      var configs = window.TPOConfigs && window.TPOConfigs.product_options_easify;
      if (!configs) return map;
      configs.forEach(function(config) {
        var opts = ((config.option_set || {}).options) || [];
        opts.forEach(function(opt) {
          (opt.option_types || []).forEach(function(t) {
            if (t.label && t.color_code) {
              map[t.label.toLowerCase()] = t.color_code.split(',').filter(Boolean);
            }
          });
        });
      });
    } catch(e) {}
    return map;
  }

  // Read the mode set by the store owner in Shopify customizer
  function getOwnerMode() {
    var section = document.querySelector('[data-section-type="product"]');
    return section ? (section.getAttribute('data-swatch-mode') || 'colour') : 'colour';
  }

  // ── Collapse helper ────────────────────────────────────────────────────────
  function collapseWrapper(wrapper) {
    if (wrapper.querySelector('.ColorCollapse__Toggle')) return;
    var children = Array.from(wrapper.children);
    if (children.length <= 5) return;

    var hidden = [];
    children.forEach(function(item, idx) {
      if (idx >= 5) { item.style.display = 'none'; hidden.push(item); }
    });

    wrapper.style.flexWrap = 'nowrap';
    wrapper.style.alignItems = 'center';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ColorCollapse__Toggle';
    btn.innerHTML = 'More colours <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';
    btn.style.cssText = 'display:inline-flex;align-items:center;gap:4px;font-size:11.5px;font-weight:500;color:#555;background:none;border:none;cursor:pointer;padding:4px 8px;white-space:nowrap;flex-shrink:0;letter-spacing:0.02em;transition:color 0.15s;';
    btn.addEventListener('mouseenter', function() { btn.style.color = '#1a1a1a'; });
    btn.addEventListener('mouseleave', function() { btn.style.color = '#555'; });

    var expanded = false;
    btn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation();
      expanded = !expanded;
      if (expanded) {
        wrapper.style.flexWrap = 'wrap';
        hidden.forEach(function(el) { el.style.display = ''; });
        btn.innerHTML = 'Less <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"/></svg>';
      } else {
        wrapper.style.flexWrap = 'nowrap';
        hidden.forEach(function(el) { el.style.display = 'none'; });
        btn.innerHTML = 'More colours <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';
      }
    });
    wrapper.appendChild(btn);
  }

  // ── IMAGE-SWATCHES (Easify has images configured) ──────────────────────────
  function initImageSwatches(wrapper, mode) {
    if (mode === 'colour') {
      // Owner chose colour circles — override pattern images with flat hex colours
      var colorMap = buildColorMap();
      wrapper.querySelectorAll('.tpo_image-swatch-option').forEach(function(el) {
        var img = el.querySelector('img');
        var label = (el.getAttribute('data-value') || el.getAttribute('title') || '').toLowerCase();
        if (!label) {
          var lbl = el.querySelector('[class*="tooltip"]');
          if (lbl) label = lbl.textContent.trim().toLowerCase();
        }
        if (img) img.style.opacity = '0';
        var colors = colorMap[label] || [];
        if (colors.length === 1) {
          el.style.background = colors[0];
        } else if (colors.length >= 2) {
          el.style.background = 'linear-gradient(135deg, ' + colors[0] + ' 50%, ' + colors[1] + ' 50%)';
        }
      });
    }
    // pattern mode: Easify's own images already show — nothing to do
    collapseWrapper(wrapper);
  }

  // ── COLOR-SWATCHES (solid circles) ────────────────────────────────────────
  function initColorSwatches(wrapper, mode) {
    if (mode === 'pattern') {
      // Owner chose pattern — fetch and apply product images
      // Individual swatch items have class tpo_color-swatches-wrapper (confusingly named)
      wrapper.querySelectorAll('.tpo_color-swatches-wrapper, a[href*="/products/"]').forEach(function(el) {
        var href = el.getAttribute('href') || '';
        var handle = href.split('/products/')[1];
        if (!handle) return;
        handle = handle.split('?')[0].split('#')[0];
        var circle = el.querySelector('[style*="background"]') || el;
        getProductImage(handle).then(function(src) {
          if (!src) return;
          circle.style.backgroundImage = 'url(' + src + ')';
          circle.style.backgroundSize = 'cover';
          circle.style.backgroundPosition = 'center';
        });
      });
    }
    // colour mode: circles already correct — nothing to do
    collapseWrapper(wrapper);
  }

  // ── Entry point ───────────────────────────────────────────────────────────
  function initSwatches() {
    var mode = getOwnerMode();
    // Correct selectors: the OUTER container (holds all swatches) uses tpo_option-type-*
    var imageWrapper = document.querySelector('.tpo_option-type-image-swatches-wrapper');
    var colorWrapper = document.querySelector('.tpo_option-type-color-swatches-wrapper');

    if (imageWrapper && !imageWrapper.dataset.swatchInit) {
      if (imageWrapper.querySelectorAll('.tpo_image-swatch-option').length > 1) {
        imageWrapper.dataset.swatchInit = '1';
        initImageSwatches(imageWrapper, mode);
      }
    }
    if (colorWrapper && !colorWrapper.dataset.swatchInit) {
      if (colorWrapper.querySelectorAll('.tpo_color-swatches-wrapper').length > 1) {
        colorWrapper.dataset.swatchInit = '1';
        initColorSwatches(colorWrapper, mode);
      }
    }
  }

  function observeForSwatches() {
    var debounceTimer;
    var observer;
    var fired = false;

    function runNow() {
      if (fired) return;
      var imageWrapper = document.querySelector('.tpo_option-type-image-swatches-wrapper');
      var colorWrapper = document.querySelector('.tpo_option-type-color-swatches-wrapper');
      var wrapper = imageWrapper || colorWrapper;
      if (!wrapper) return;
      var items = wrapper.querySelectorAll('.tpo_image-swatch-option, .tpo_color-swatches-wrapper');
      if (items.length < 2) return;
      fired = true;
      if (observer) { observer.disconnect(); observer = null; }
      // Clear any premature swatchInit so initSwatches always runs with final count
      if (imageWrapper) delete imageWrapper.dataset.swatchInit;
      if (colorWrapper) delete colorWrapper.dataset.swatchInit;
      initSwatches();
    }

    function scheduleInit() {
      if (fired) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(runNow, 200);
    }

    // Scheduled polls catch Easify that renders after initial load
    [0, 300, 700, 1500, 3000].forEach(function(d) { setTimeout(scheduleInit, d); });

    // Observer catches DOM changes as Easify renders
    var watchTarget = document.querySelector('[data-section-type="product"]') || document.body;
    observer = new MutationObserver(scheduleInit);
    observer.observe(watchTarget, { childList: true, subtree: true });

    // Hard fallback
    setTimeout(function() {
      if (observer) { observer.disconnect(); observer = null; }
      runNow();
    }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeForSwatches);
  } else {
    observeForSwatches();
  }

  // After AJAX colour nav swaps the section, re-observe from scratch
  window.collapseColorSwatches = observeForSwatches;
})();
